import { FeedbackState } from '../types/FeedbackState';

export const isFeedbackState = (arg: any): arg is FeedbackState => !!arg
  && arg.lastVisitTime !== undefined
  && arg.visitCounter !== undefined
  && arg.popupShown !== undefined;
